const TEXT_LIMIT = 50;
const WEEKDAYS = [
  { label: "Sun", id: 0 },
  { label: "Mon", id: 1 },
  { label: "Tue", id: 2 },
  { label: "Wed", id: 3 },
  { label: "Thu", id: 4 },
  { label: "Fri", id: 5 },
  { label: "Sat", id: 6 },
];
const AWS_CHUNK_SIZE = 8 * 1024 * 1024; // 8MB
const CLOUDFLARE_CHUNK_SIZE = 20 * 1024 * 1024; // 20MB
export const USER_UPLOAD_MAX_SIZE_GB = 3;
export const ADMIN_UPLOAD_MAX_SIZE_GB = 15;

export const SCORM_COURSE_FOLDER = "interactive-courses";
export const CMI5_COURSE_FOLDER = "cmi5-courses";

export { TEXT_LIMIT, WEEKDAYS, AWS_CHUNK_SIZE, CLOUDFLARE_CHUNK_SIZE };

export const DND_ITEM_TYPES = {
  SECTION: "SECTION",
  SUBSECTION: "SUBSECTION",
  MODULE: "MODULE",
};

export const SHOP_URL = process.env.REACT_APP_SHOP_URL;
export const MINDHUB_URL = "https://www.academylogin.com";

export const HIDDEN_LIST = ["VISIBLE", "HIDDEN"];

export const KNOWLEDGE_LEVEL_MAP = {
  null: "No Level",
  1: "Beginner",
  3: "Advanced",
  4: "All Levels",
};

export const KNOWLEDGE_LEVEL_OPTIONS = [
  { label: "No Level", value: null },
  { label: "Beginner", value: 1 },
  { label: "Advanced", value: 3 },
  { label: "All Levels", value: 4 },
];

// Content with no market is open to everyone, including freemium users — they hold no market
// picks of their own, so anything carrying a market stays locked for them. Each form builds its
// own option around this label because the market field is shaped differently in each one.
export const NO_MARKET_LABEL = "No Market (open to everyone)";
